const header = document.querySelector('.site-header');
const menuToggle = document.querySelector('.menu-toggle');
const mobileMenu = document.querySelector('.mobile-menu');

window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 18), { passive: true });

menuToggle?.addEventListener('click', () => {
  const open = mobileMenu.classList.toggle('open');
  menuToggle.classList.toggle('open', open);
  menuToggle.setAttribute('aria-expanded', open);
});
mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
  mobileMenu.classList.remove('open'); menuToggle.classList.remove('open'); menuToggle.setAttribute('aria-expanded', 'false');
}));

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('visible'); revealObserver.unobserve(entry.target); } });
}, { threshold: 0.14 });
document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

const countObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    const counter = entry.target;
    const goal = Number(counter.dataset.count);
    const decimal = counter.dataset.decimal === 'true';
    const suffix = counter.dataset.suffix || '';
    const start = performance.now();
    const duration = 1250;
    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = goal * eased;
      counter.textContent = (decimal ? value.toFixed(1) : Math.round(value).toLocaleString('de-DE')) + suffix;
      if (progress < 1) requestAnimationFrame(update);
    };
    requestAnimationFrame(update); countObserver.unobserve(counter);
  });
}, { threshold: .7 });
document.querySelectorAll('[data-count]').forEach((el) => countObserver.observe(el));

document.querySelectorAll('.tilt-card').forEach((card) => {
  card.addEventListener('mousemove', (event) => {
    if (window.innerWidth < 720) return;
    const rect = card.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - .5;
    const y = (event.clientY - rect.top) / rect.height - .5;
    card.style.transform = `perspective(900px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg) translateY(-4px)`;
  });
  card.addEventListener('mouseleave', () => { card.style.transform = ''; });
});

document.querySelectorAll('.choice-row').forEach((group) => {
  group.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
    group.querySelectorAll('button').forEach((item) => item.classList.remove('active'));
    button.classList.add('active');
    if (group.dataset.group === 'color') {
      const stand = document.querySelector('#preview-stand');
      stand.classList.remove('black', 'white', 'clear'); stand.classList.add(button.dataset.value);
    }
    if (group.dataset.group === 'product') {
      const product = button.dataset.value;
      document.querySelector('#preview-product').textContent = product === 'Speisekarte' ? 'DIGITALE SPEISEKARTE' : product === 'Individuell' ? 'DEIN EIGENES ZIEL' : 'GOOGLE-BEWERTUNG';
      document.querySelector('#preview-stars').style.opacity = product === 'Speisekarte' ? '.25' : '1';
      document.querySelector('#preview-target').textContent = product === 'Speisekarte' ? 'Menü öffnen' : product === 'Individuell' ? 'Jetzt entdecken' : 'Jetzt bewerten';
    }
  }));
});

const signText = document.querySelector('#sign-text');
signText?.addEventListener('input', () => {
  const safeText = signText.value.trim() || 'Hat es dir gefallen?';
  const halfway = Math.ceil(safeText.length / 2);
  document.querySelector('#preview-text').innerHTML = `${safeText.slice(0, halfway)}<br>${safeText.slice(halfway)}`;
});

document.querySelector('#nfc-target')?.addEventListener('change', (event) => {
  const label = event.target.value;
  const target = document.querySelector('#preview-target');
  target.textContent = label === 'Google Bewertung' ? 'Jetzt bewerten' : label === 'Digitale Speisekarte' ? 'Menü öffnen' : `${label} öffnen`;
});

document.querySelector('.upload-field input')?.addEventListener('change', (event) => {
  const file = event.target.files?.[0];
  if (!file) return;
  const reader = new FileReader();
  reader.addEventListener('load', () => {
    const logo = document.querySelector('#preview-logo');
    logo.src = reader.result;
    logo.classList.add('visible');
  });
  reader.readAsDataURL(file);
});

window.addEventListener('scroll', () => {
  const y = window.scrollY;
  document.querySelectorAll('[data-parallax]').forEach((el) => {
    el.style.transform = `translateY(${y * Number(el.dataset.parallax)}px)`;
  });
}, { passive: true });

// Shopify cart integration
const shopRoot = window.Shopify?.routes?.root || '/';
const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartContent = document.querySelector('[data-cart-content]');
const cartCountNodes = document.querySelectorAll('[data-cart-count]');

const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
const setCartCount = (count) => cartCountNodes.forEach((node) => { node.textContent = count; });

function renderDrawer(cart) {
  if (!cartContent) return;
  if (!cart.item_count) {
    cartContent.innerHTML = '<div class="drawer-empty"><span>⌁</span><p>Dein Warenkorb ist leer.</p><a class="button" href="' + shopRoot + '#produkte" data-cart-close>Produkte entdecken <span>→</span></a></div>';
    return;
  }
  const items = cart.items.map((item) => {
    const variantTitle = String(item.variant_title || '').trim();
    const variant = variantTitle && !['Default Title', 'null'].includes(variantTitle) ? variantTitle + ' · ' : '';
    return '<div class="drawer-item"><img src="' + (item.image || '') + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '"><div><strong>' + item.product_title + '</strong><small>' + variant + item.quantity + '×</small><b>' + money(item.final_line_price) + '</b><div class="drawer-quantity" data-cart-quantity><button type="button" data-cart-change="-1" data-cart-key="' + item.key + '" aria-label="Menge verringern">−</button><input type="number" min="1" step="1" value="' + item.quantity + '" inputmode="numeric" data-cart-quantity-input data-cart-key="' + item.key + '" aria-label="Menge für ' + item.product_title.replace(/"/g, '&quot;') + '"><button type="button" data-cart-change="1" data-cart-key="' + item.key + '" aria-label="Menge erhöhen">+</button></div></div></div>';
  }).join('');
  cartContent.innerHTML = '<div class="drawer-items">' + items + '</div><div class="drawer-total"><span>Zwischensumme</span><strong>' + money(cart.total_price) + '</strong><a class="button" href="' + shopRoot + 'checkout">Sicher zur Kasse <span>→</span></a><a class="drawer-cart-link" href="' + shopRoot + 'cart">Warenkorb ansehen</a></div>';
}

async function fetchCart() {
  const response = await fetch(shopRoot + 'cart.js');
  const cart = await response.json();
  setCartCount(cart.item_count); renderDrawer(cart); return cart;
}
function openCart() { cartDrawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('cart-is-open'); fetchCart().catch(() => {}); }
function closeCart() { cartDrawer?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('cart-is-open'); }
document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openCart(); }));
document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
async function changeCartQuantity(key, quantity) {
  if (!key || quantity < 1) return;
  try {
    const response = await fetch(shopRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Cart quantity request failed');
    const cart = await response.json();
    setCartCount(cart.item_count);
    renderDrawer(cart);
  } catch (error) {
    fetchCart().catch(() => {});
  }
}
cartContent?.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-change]');
  if (!button) return;
  const input = button.closest('[data-cart-quantity]')?.querySelector('[data-cart-quantity-input]');
  const current = Math.max(1, Number(input?.value) || 1);
  const quantity = Math.max(1, current + Number(button.dataset.cartChange));
  changeCartQuantity(button.dataset.cartKey, quantity);
});
cartContent?.addEventListener('change', (event) => {
  const input = event.target.closest('[data-cart-quantity-input]');
  if (!input) return;
  changeCartQuantity(input.dataset.cartKey, Math.max(1, Number(input.value) || 1));
});

async function addToCart(formData, trigger) {
  if (trigger) { trigger.disabled = true; trigger.dataset.originalText = trigger.innerHTML; trigger.innerHTML = 'Wird hinzugefügt…'; }
  try {
    const response = await fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    if (!response.ok) throw new Error('Cart request failed');
    await fetchCart(); openCart();
  } catch (error) {
    if (trigger) trigger.innerHTML = 'Bitte erneut versuchen';
  } finally {
    if (trigger) window.setTimeout(() => { trigger.disabled = false; trigger.innerHTML = trigger.dataset.originalText || trigger.innerHTML; }, 1300);
  }
}
document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addToCart(new FormData(form), form.querySelector('[type="submit"]')); }));

let configVariantId = document.querySelector('[data-group="product"] .choice.active')?.dataset.variantId || '';
let configProductUrl = document.querySelector('[data-group="product"] .choice.active')?.dataset.productUrl || '';
const configAdd = document.querySelector('[data-config-add]');
const configLink = document.querySelector('[data-config-product-link]');
const configPrice = document.querySelector('[data-config-price]');
document.querySelectorAll('[data-group="product"] .choice').forEach((button) => button.addEventListener('click', () => {
  configVariantId = button.dataset.variantId || ''; configProductUrl = button.dataset.productUrl || '';
  if (configAdd) configAdd.disabled = !configVariantId;
  if (configLink) { configLink.href = configProductUrl || '#tap-konfigurator'; configLink.textContent = configVariantId ? 'Produktdetails ansehen' : 'Produkte im Theme Editor zuweisen'; }
  if (configPrice) configPrice.textContent = (button.dataset.price || 'Preis nach Produktauswahl') + ' · inkl. NFC-Chip';
}));
configAdd?.addEventListener('click', () => { if (!configVariantId) return; const data = new FormData(); data.append('id', configVariantId); data.append('quantity', '1'); addToCart(data, configAdd); });
